import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import React from "react";

export const ButtonExport = styled(props => <Button {...props}/>)`
    /* Sin margen propio: el hueco lo da el gap de la cabecera y el último botón llega al borde */
    margin-right: 0 !important;
`
